import { debounce } from "nuqs";
import { useMemo } from "react";

export const disableReactQuillClasses = (isDisabled: boolean) => {
	return isDisabled ? "pointer-events-none cursor-not-allowed" : "";
};

/**
 * Generate a stable localId for client-side tracking. Uses crypto.randomUUID()
 * when available (modern browsers + JSDOM 22+), with a deterministic fallback
 * for older test environments.
 * @returns unique value string
 */
export const safeRandomUUID = (): string => {
	/** eslint-disable-next-line no-restricted-syntax **/
	if (
		typeof globalThis !== "undefined" &&
		globalThis.crypto &&
		typeof globalThis.crypto.randomUUID === "function"
	) {
		/** eslint-disable-next-line no-restricted-syntax **/
		return globalThis.crypto.randomUUID();
	}
	return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};
